"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_sortable_hoc_1 = require("react-sortable-hoc");
var styles_1 = require("@material-ui/core/styles");
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var DragIndicator_1 = __importDefault(require("@material-ui/icons/DragIndicator"));
var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
var ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
var ListItemSecondaryAction_1 = __importDefault(require("@material-ui/core/ListItemSecondaryAction"));
var ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var zIndex = _a.zIndex, palette = _a.palette;
    return ({
        listItemRoot: {
            zIndex: zIndex.tooltip,
            listStyle: 'none',
            backgroundColor: palette.common.white
        },
        dragIndicator: {
            color: palette.text.secondary,
            cursor: 'pointer'
        }
    });
});
var DragHandle = (0, react_sortable_hoc_1.SortableHandle)(function () {
    var classes = useStyles();
    return (react_1.default.createElement(DragIndicator_1.default, { className: classes.dragIndicator }));
});
var Item = function (props) {
    var id = props.id, checked = props.checked, label = props.label, _a = props.isStatic, isStatic = _a === void 0 ? false : _a, onChangeColumn = props.onChangeColumn, _b = props.showDragHandle, showDragHandle = _b === void 0 ? true : _b;
    var classes = useStyles();
    return (react_1.default.createElement(ListItem_1.default, { divider: true, classes: { container: classes.listItemRoot } },
        react_1.default.createElement(ListItemIcon_1.default, null,
            react_1.default.createElement(Checkbox_1.default, { key: id, value: id, onChange: onChangeColumn, checked: checked, disabled: isStatic })),
        react_1.default.createElement(ListItemText_1.default, { id: id, primary: label }),
        react_1.default.createElement(ListItemSecondaryAction_1.default, null, (!isStatic && showDragHandle) && react_1.default.createElement(DragHandle, null))));
};
exports.default = Item;
